<div class="modal-header">
  <h4 class="modal-title">Define sample files</h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.close()"></button>
</div>

<div class="modal-body">
  @if (state.isReady()) {
    <div class="h-100">
      <div class="alert alert-warning p-1" [class.invisible]="!nonUniqueWarning">
        <i class="fas fa-fw fa-exclamation-circle"></i>
        {{ nonUniqueWarningText }}
      </div>

      <!-- single or paired selection-->
      <div class="row">
        <div class="col">
          <form [formGroup]="singleOrPairedForm" (ngSubmit)="onFindPairs()">
            <input type="radio" class="me-1" value="paired" formControlName="singleOrPaired" />
            Paired end
            <input type="radio" class="ms-2 me-1" value="single" formControlName="singleOrPaired" />
            Single end
          </form>
        </div>
        <div class="col align-self-end">
          <button type="button" (click)="onResetAll()" class="btn btn-sm btn-secondary ms-2 float-end">
            Reset all
          </button>
        </div>
      </div>

      <!--- set single button -->
      <div>
        @if (singleOrPairedForm.get("singleOrPaired").value === "single") {
          <button [disabled]="!singleTokenForm.valid" class="btn btn-sm btn-success" (click)="onFindSingle()">
            One file per sample
          </button>
        }
      </div>

      <!-- paired tokens and find-->
      @if (singleOrPairedForm.get("singleOrPaired").value === "paired") {
        <form [formGroup]="identifiersForm" (ngSubmit)="onFindPairs()">
          <div class="form-group">
            <div class="row">
              <div class="col">
                <label for="r1TokenInput" class="text-sm">Forward Identifier</label>
                <input
                  type="text"
                  required
                  placeholder="Identifier found in forward reads file names"
                  class="form-control form-control-sm"
                  formControlName="r1Token"
                  id="r1TokenInput" />
              </div>
              <div class="col">
                <label for="r2TokenInput" class="text-sm">Reverse Identifier</label>
                <input
                  type="text"
                  required
                  placeholder="Identifier found in reverse reads file names"
                  class="form-control form-control-sm"
                  formControlName="r2Token"
                  id="r2TokenInput" />
              </div>
              <div class="col align-self-end float-end">
                <button type="submit" [disabled]="!identifiersForm.valid" class="btn btn-sm btn-success">
                  Find pairs
                </button>
              </div>
            </div>
          </div>
        </form>
      }

      @if (unpairedFiles.length > 0) {
        <div>
          <h2 class="h2-xs">Undefined Files</h2>
          <div>
            <span class="text-sm">
              {{ unpairedFiles.length }} undefined file{{ getPluralEnd(unpairedFiles.length) }}
            </span>
            <button (click)="onResetAll()" class="btn btn-sm btn-secondary float-end invisible mb-1">
              Reset everything
            </button>
          </div>
          <hr class="mt-1 mb-1" />
          <div class="limit-height">
            @for (dataset of unpairedFiles; track dataset.datasetId) {
              <div class="">{{ dataset.name }}</div>
            }
          </div>
        </div>
      }

      @if (singleEndSamples.length > 0) {
        <div>
          <h2 class="h2-xs mt-3">Samples &#8208; Single End</h2>
          <div class="">
            <span class="text-sm">{{ singleEndSamples.length }} sample{{ getPluralEnd(singleEndSamples.length) }}</span>
            @if (singleEndSamples.length > 0) {
              <button (click)="onResetSingle()" class="btn btn-sm btn-secondary float-end mb-1">Reset</button>
            }
          </div>

          <div class="limit-height">
            <table class="table table-sm table-striped table-bordered">
              <tbody>
                @for (singleEndSample of singleEndSamples; track singleEndSample.file.datasetId) {
                  <tr>
                    <td>{{ singleEndSample.file.name }}</td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        </div>
      }

      @if (pairedEndSamples.length > 0) {
        <div>
          <h2 class="h2-xs mt-3">Samples &#8208; Paired End</h2>
          <div class="">
            <span class="text-sm">
              {{ pairedEndSamples.length }} sample{{ getPluralEnd(pairedEndSamples.length) }},
              {{ pairedEndSamples.length * 2 }} files
            </span>
            @if (pairedEndSamples.length > 0) {
              <button (click)="onResetPairs()" class="btn btn-sm btn-secondary float-end mb-1">Reset</button>
            }
          </div>

          <div class="limit-height">
            @if (pairedEndSamples.length > 0) {
              <table class="table table-sm table-striped table-bordered">
                <thead class="text-center">
                  <th><i class="far fa-arrow-alt-circle-right"></i></th>
                  <th><i class="far fa-arrow-alt-circle-left"></i></th>
                </thead>
                <tbody>
                  @for (pairedEndSample of pairedEndSamples; track pairedEndSample.sampleId) {
                    <tr>
                      <td>{{ pairedEndSample.pairs[0].r1File.name }}</td>
                      <td>{{ pairedEndSample.pairs[0].r2File.name }}</td>
                    </tr>
                  }
                </tbody>
              </table>
            }
          </div>
        </div>
      }

      @if (pairMissingSamples.length > 0) {
        <div>
          <h2 class="h2-xs mt-3">Paired End Samples with Missing Pair</h2>
          <div class="">
            <span class="text-sm">
              {{ pairMissingSamples.length }} missing pair{{ getPluralEnd(pairMissingSamples.length) }}
            </span>
            <button (click)="onResetMissing()" class="btn btn-sm btn-secondary float-end mb-1">Reset</button>
          </div>

          <div class="limit-height">
            <table class="table table-sm table-striped table-bordered">
              <thead class="text-center">
                <th class="w-50"><i class="far fa-arrow-alt-circle-right"></i></th>
                <th class="w-50"><i class="far fa-arrow-alt-circle-left"></i></th>
              </thead>
              <tbody>
                @for (pairedEndSample of pairMissingSamples; track pairedEndSample.sampleId) {
                  <tr>
                    @if (pairedEndSample.pairs[0].r1File != null) {
                      <td>{{ pairedEndSample.pairs[0].r1File.name }}</td>
                    }
                    @if (pairedEndSample.pairs[0].r1File == null) {
                      <td><i>missing</i></td>
                    }
                    @if (pairedEndSample.pairs[0].r2File != null) {
                      <td>{{ pairedEndSample.pairs[0].r2File.name }}</td>
                    }
                    @if (pairedEndSample.pairs[0].r2File == null) {
                      <td><i>missing</i></td>
                    }
                  </tr>
                }
              </tbody>
            </table>
          </div>
        </div>
      }
    </div>
  } @else {
    <ch-status [state]="state"></ch-status>
  }
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-sm btn-secondary float-start" (click)="activeModal.close()">Close</button>
  <button type="button" class="btn btn-sm btn-success" (click)="onSave()">Save</button>
</div>
